// used for page-load and page-segment-load events
export const FF_ALLOWLIST_FOR_PERF_METRICS = [
	'confluence.ssr.page-statuses',
	'analytics-next-use-modern-context_jira',
	'confluence_ssr_enable_tesseract_stream_endpoint',
	'confluence_use_canary',
	'confluence_use_parcel',
	'confluence_ssr_load_after_paint_loadables_as_paint',
	'confluence_ssr_enable_hydration',
	'confluence_react_streaming',
	'confluence_preload_forge_viewport_heights',
	'confluence_frontend_vc_observer_initialization',
	'confluence_frontend_remove_comments_placeholder',
	'enable_loadable_placeholder_for_legacy_macros',
	'edition_awareness_standard_upsell_confluence_ab',
	'edition_awareness_standard_upsell_confluence_ab_fg',
	'confluence_frontend_content_body_container',
	'platform-ssr-table-resize',
	'edit-team-connection-from-confluence',
	'confluence_frontend_ssr_autohighlights',
	'cc_mention_ssr_placeholder',
	'confluence_frontend_ssr_empty_footer_comments',
	'confluence_frontend_exclude_page_properties_vc',
	'platform_editor_fix_image_size_diff_during_ssr',
	'confluence_skip_ssr_redirect_incorrect_slug',
	'platform_ssr_smartlinks_editor',
	'confluence_preload_smartlink_live_page',
	'content_early_connect_iframe_initialization',
	'confluence_preload_pagetree_space_transition',
	'confluence_frontend_fix_smart_link_flickering',
	'confluence_frontend_cookie_banner_min_height',
	'confluence_emit_v3_debug_data',
	'nav4_confluence_global_links',
	'confluence_preload_tenant_license_gas',
	'webpanel_early_connect_iframe_initialization',
	'confluence_frontend_ssr_superbatch_preloading',
	'confluence_frontend_nav_spotlight_press_tracing',
	'cc-ssr-preload-create-intro-first-step',
	'cc_complexit_fe_skip_read_time_query_content_body',
];

// In order to reduce BM event payload size, include a FF in the BM payload only if it's in the allow list.
// The following FFs will be included in all types of BM event.
export const ALLOWLIST_FFS_CUSTOM_EVENTS = [];
